/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as PublicRouteRouteImport } from './routes/_public/route'
import { Route as AuthenticatedAccountRouteRouteImport } from './routes/_authenticated/_account/route'
import { Route as AuthenticatedSelectFleetRouteImport } from './routes/_authenticated/select-fleet'
import { Route as AuthenticatedAccountDashboardRouteRouteImport } from './routes/_authenticated/_account/dashboard/route'
import { Route as AuthenticatedInviteInviteIdRouteRouteImport } from './routes/_authenticated/invite/$inviteId/route'
import { Route as AuthenticatedSettingsIndexRouteImport } from './routes/_authenticated/settings/index'
import { Route as AuthenticatedSupportIndexRouteImport } from './routes/_authenticated/support/index'
import { Route as AuthenticatedWelcomeIndexRouteImport } from './routes/_authenticated/welcome/index'
import { Route as PublicFaqIndexRouteImport } from './routes/_public/faq/index'
import { Route as PublicLoginIndexRouteImport } from './routes/_public/login/index'
import { Route as AuthenticatedAccountCampaignsIndexRouteImport } from './routes/_authenticated/_account/campaigns/index'
import { Route as AuthenticatedAccountDashboardIndexRouteImport } from './routes/_authenticated/_account/dashboard/index'
import { Route as AuthenticatedAccountFleetsIndexRouteImport } from './routes/_authenticated/_account/fleets/index'
import { Route as AuthenticatedAccountFleetsFleetIdRouteRouteImport } from './routes/_authenticated/_account/fleets/$fleetId/route'
import { Route as AuthenticatedAccountMembersIndexRouteImport } from './routes/_authenticated/_account/members/index'
import { Route as AuthenticatedAccountUnitsIndexRouteImport } from './routes/_authenticated/_account/units/index'
import { Route as AuthenticatedAccountUnitsEndCustomerUnitIdRouteRouteImport } from './routes/_authenticated/_account/units/$endCustomerUnitId/route'
import { Route as AuthenticatedAccountDashboardActiveFaultCodesIndexRouteImport } from './routes/_authenticated/_account/dashboard/active-fault-codes/index'
import { Route as AuthenticatedAccountDashboardConnectivityIndexRouteImport } from './routes/_authenticated/_account/dashboard/connectivity/index'
import { Route as AuthenticatedAccountDashboardFuelConsumptionIndexRouteImport } from './routes/_authenticated/_account/dashboard/fuel-consumption/index'
import { Route as AuthenticatedAccountFleetsFleetIdDashboardRouteRouteImport } from './routes/_authenticated/_account/fleets/$fleetId/dashboard/route'
import { Route as AuthenticatedAccountMembersEndUserIdIndexRouteImport } from './routes/_authenticated/_account/members/$endUserId/index'
import { Route as AuthenticatedAccountUnitsEndCustomerUnitIdIndexRouteImport } from './routes/_authenticated/_account/units/$endCustomerUnitId/index'
import { Route as AuthenticatedAccountFleetsFleetIdCampaignsIndexRouteImport } from './routes/_authenticated/_account/fleets/$fleetId/campaigns/index'
import { Route as AuthenticatedAccountFleetsFleetIdDashboardIndexRouteImport } from './routes/_authenticated/_account/fleets/$fleetId/dashboard/index'
import { Route as AuthenticatedAccountFleetsFleetIdUnitsIndexRouteImport } from './routes/_authenticated/_account/fleets/$fleetId/units/index'
import { Route as AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdRouteRouteImport } from './routes/_authenticated/_account/fleets/$fleetId/units/$endCustomerUnitId/route'
import { Route as AuthenticatedAccountUnitsEndCustomerUnitIdCampaignsIndexRouteImport } from './routes/_authenticated/_account/units/$endCustomerUnitId/campaigns/index'
import { Route as AuthenticatedAccountUnitsEndCustomerUnitIdCoverageIndexRouteImport } from './routes/_authenticated/_account/units/$endCustomerUnitId/coverage/index'
import { Route as AuthenticatedAccountUnitsEndCustomerUnitIdDiagnosticsIndexRouteImport } from './routes/_authenticated/_account/units/$endCustomerUnitId/diagnostics/index'
import { Route as AuthenticatedAccountUnitsEndCustomerUnitIdMaintenanceIndexRouteImport } from './routes/_authenticated/_account/units/$endCustomerUnitId/maintenance/index'
import { Route as AuthenticatedAccountUnitsEndCustomerUnitIdPublicationsIndexRouteImport } from './routes/_authenticated/_account/units/$endCustomerUnitId/publications/index'
import { Route as AuthenticatedAccountUnitsEndCustomerUnitIdServicesIndexRouteImport } from './routes/_authenticated/_account/units/$endCustomerUnitId/services/index'
import { Route as AuthenticatedAccountUnitsEndCustomerUnitIdSettingsIndexRouteImport } from './routes/_authenticated/_account/units/$endCustomerUnitId/settings/index'
import { Route as AuthenticatedAccountUnitsEndCustomerUnitIdSpecificationsIndexRouteImport } from './routes/_authenticated/_account/units/$endCustomerUnitId/specifications/index'
import { Route as AuthenticatedAccountFleetsFleetIdDashboardActiveFaultCodesIndexRouteImport } from './routes/_authenticated/_account/fleets/$fleetId/dashboard/active-fault-codes/index'
import { Route as AuthenticatedAccountFleetsFleetIdDashboardConnectivityIndexRouteImport } from './routes/_authenticated/_account/fleets/$fleetId/dashboard/connectivity/index'
import { Route as AuthenticatedAccountFleetsFleetIdDashboardFuelConsumptionIndexRouteImport } from './routes/_authenticated/_account/fleets/$fleetId/dashboard/fuel-consumption/index'
import { Route as AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdIndexRouteImport } from './routes/_authenticated/_account/fleets/$fleetId/units/$endCustomerUnitId/index'
import { Route as AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdMaintenanceRouteRouteImport } from './routes/_authenticated/_account/fleets/$fleetId/units/$endCustomerUnitId/maintenance/route'
import { Route as AuthenticatedAccountUnitsEndCustomerUnitIdMaintenanceProtocolKeyIndexRouteImport } from './routes/_authenticated/_account/units/$endCustomerUnitId/maintenance/$protocolKey/index'
import { Route as AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdCampaignsIndexRouteImport } from './routes/_authenticated/_account/fleets/$fleetId/units/$endCustomerUnitId/campaigns/index'
import { Route as AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdCoverageIndexRouteImport } from './routes/_authenticated/_account/fleets/$fleetId/units/$endCustomerUnitId/coverage/index'
import { Route as AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdDiagnosticsIndexRouteImport } from './routes/_authenticated/_account/fleets/$fleetId/units/$endCustomerUnitId/diagnostics/index'
import { Route as AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdMaintenanceIndexRouteImport } from './routes/_authenticated/_account/fleets/$fleetId/units/$endCustomerUnitId/maintenance/index'
import { Route as AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdPublicationsIndexRouteImport } from './routes/_authenticated/_account/fleets/$fleetId/units/$endCustomerUnitId/publications/index'
import { Route as AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdServicesIndexRouteImport } from './routes/_authenticated/_account/fleets/$fleetId/units/$endCustomerUnitId/services/index'
import { Route as AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdSettingsIndexRouteImport } from './routes/_authenticated/_account/fleets/$fleetId/units/$endCustomerUnitId/settings/index'
import { Route as AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdSpecificationsIndexRouteImport } from './routes/_authenticated/_account/fleets/$fleetId/units/$endCustomerUnitId/specifications/index'
import { Route as AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdMaintenanceProtocolKeyIndexRouteImport } from './routes/_authenticated/_account/fleets/$fleetId/units/$endCustomerUnitId/maintenance/$protocolKey/index'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicRouteRoute = PublicRouteRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedAccountRouteRoute =
  AuthenticatedAccountRouteRouteImport.update({
    id: '/_account',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSelectFleetRoute =
  AuthenticatedSelectFleetRouteImport.update({
    id: '/select-fleet',
    path: '/select-fleet',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAccountDashboardRouteRoute =
  AuthenticatedAccountDashboardRouteRouteImport.update({
    id: '/dashboard',
    path: '/dashboard',
    getParentRoute: () => AuthenticatedAccountRouteRoute,
  } as any)
const AuthenticatedInviteInviteIdRouteRoute =
  AuthenticatedInviteInviteIdRouteRouteImport.update({
    id: '/invite/$inviteId',
    path: '/invite/$inviteId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSettingsIndexRoute =
  AuthenticatedSettingsIndexRouteImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSupportIndexRoute =
  AuthenticatedSupportIndexRouteImport.update({
    id: '/support/',
    path: '/support/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedWelcomeIndexRoute =
  AuthenticatedWelcomeIndexRouteImport.update({
    id: '/welcome/',
    path: '/welcome/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const PublicFaqIndexRoute = PublicFaqIndexRouteImport.update({
  id: '/faq/',
  path: '/faq/',
  getParentRoute: () => PublicRouteRoute,
} as any)
const PublicLoginIndexRoute = PublicLoginIndexRouteImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => PublicRouteRoute,
} as any)
const AuthenticatedAccountCampaignsIndexRoute =
  AuthenticatedAccountCampaignsIndexRouteImport.update({
    id: '/campaigns/',
    path: '/campaigns/',
    getParentRoute: () => AuthenticatedAccountRouteRoute,
  } as any)
const AuthenticatedAccountDashboardIndexRoute =
  AuthenticatedAccountDashboardIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAccountDashboardRouteRoute,
  } as any)
const AuthenticatedAccountFleetsIndexRoute =
  AuthenticatedAccountFleetsIndexRouteImport.update({
    id: '/fleets/',
    path: '/fleets/',
    getParentRoute: () => AuthenticatedAccountRouteRoute,
  } as any)
const AuthenticatedAccountFleetsFleetIdRouteRoute =
  AuthenticatedAccountFleetsFleetIdRouteRouteImport.update({
    id: '/fleets/$fleetId',
    path: '/fleets/$fleetId',
    getParentRoute: () => AuthenticatedAccountRouteRoute,
  } as any)
const AuthenticatedAccountMembersIndexRoute =
  AuthenticatedAccountMembersIndexRouteImport.update({
    id: '/members/',
    path: '/members/',
    getParentRoute: () => AuthenticatedAccountRouteRoute,
  } as any)
const AuthenticatedAccountUnitsIndexRoute =
  AuthenticatedAccountUnitsIndexRouteImport.update({
    id: '/units/',
    path: '/units/',
    getParentRoute: () => AuthenticatedAccountRouteRoute,
  } as any)
const AuthenticatedAccountUnitsEndCustomerUnitIdRouteRoute =
  AuthenticatedAccountUnitsEndCustomerUnitIdRouteRouteImport.update({
    id: '/units/$endCustomerUnitId',
    path: '/units/$endCustomerUnitId',
    getParentRoute: () => AuthenticatedAccountRouteRoute,
  } as any)
const AuthenticatedAccountDashboardActiveFaultCodesIndexRoute =
  AuthenticatedAccountDashboardActiveFaultCodesIndexRouteImport.update({
    id: '/active-fault-codes/',
    path: '/active-fault-codes/',
    getParentRoute: () => AuthenticatedAccountDashboardRouteRoute,
  } as any)
const AuthenticatedAccountDashboardConnectivityIndexRoute =
  AuthenticatedAccountDashboardConnectivityIndexRouteImport.update({
    id: '/connectivity/',
    path: '/connectivity/',
    getParentRoute: () => AuthenticatedAccountDashboardRouteRoute,
  } as any)
const AuthenticatedAccountDashboardFuelConsumptionIndexRoute =
  AuthenticatedAccountDashboardFuelConsumptionIndexRouteImport.update({
    id: '/fuel-consumption/',
    path: '/fuel-consumption/',
    getParentRoute: () => AuthenticatedAccountDashboardRouteRoute,
  } as any)
const AuthenticatedAccountFleetsFleetIdDashboardRouteRoute =
  AuthenticatedAccountFleetsFleetIdDashboardRouteRouteImport.update({
    id: '/dashboard',
    path: '/dashboard',
    getParentRoute: () => AuthenticatedAccountFleetsFleetIdRouteRoute,
  } as any)
const AuthenticatedAccountMembersEndUserIdIndexRoute =
  AuthenticatedAccountMembersEndUserIdIndexRouteImport.update({
    id: '/members/$endUserId/',
    path: '/members/$endUserId/',
    getParentRoute: () => AuthenticatedAccountRouteRoute,
  } as any)
const AuthenticatedAccountUnitsEndCustomerUnitIdIndexRoute =
  AuthenticatedAccountUnitsEndCustomerUnitIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAccountUnitsEndCustomerUnitIdRouteRoute,
  } as any)
const AuthenticatedAccountFleetsFleetIdCampaignsIndexRoute =
  AuthenticatedAccountFleetsFleetIdCampaignsIndexRouteImport.update({
    id: '/campaigns/',
    path: '/campaigns/',
    getParentRoute: () => AuthenticatedAccountFleetsFleetIdRouteRoute,
  } as any)
const AuthenticatedAccountFleetsFleetIdDashboardIndexRoute =
  AuthenticatedAccountFleetsFleetIdDashboardIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAccountFleetsFleetIdDashboardRouteRoute,
  } as any)
const AuthenticatedAccountFleetsFleetIdUnitsIndexRoute =
  AuthenticatedAccountFleetsFleetIdUnitsIndexRouteImport.update({
    id: '/units/',
    path: '/units/',
    getParentRoute: () => AuthenticatedAccountFleetsFleetIdRouteRoute,
  } as any)
const AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdRouteRoute =
  AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdRouteRouteImport.update(
    {
      id: '/units/$endCustomerUnitId',
      path: '/units/$endCustomerUnitId',
      getParentRoute: () => AuthenticatedAccountFleetsFleetIdRouteRoute,
    } as any,
  )
const AuthenticatedAccountUnitsEndCustomerUnitIdCampaignsIndexRoute =
  AuthenticatedAccountUnitsEndCustomerUnitIdCampaignsIndexRouteImport.update({
    id: '/campaigns/',
    path: '/campaigns/',
    getParentRoute: () => AuthenticatedAccountUnitsEndCustomerUnitIdRouteRoute,
  } as any)
const AuthenticatedAccountUnitsEndCustomerUnitIdCoverageIndexRoute =
  AuthenticatedAccountUnitsEndCustomerUnitIdCoverageIndexRouteImport.update({
    id: '/coverage/',
    path: '/coverage/',
    getParentRoute: () => AuthenticatedAccountUnitsEndCustomerUnitIdRouteRoute,
  } as any)
const AuthenticatedAccountUnitsEndCustomerUnitIdDiagnosticsIndexRoute =
  AuthenticatedAccountUnitsEndCustomerUnitIdDiagnosticsIndexRouteImport.update({
    id: '/diagnostics/',
    path: '/diagnostics/',
    getParentRoute: () => AuthenticatedAccountUnitsEndCustomerUnitIdRouteRoute,
  } as any)
const AuthenticatedAccountUnitsEndCustomerUnitIdMaintenanceIndexRoute =
  AuthenticatedAccountUnitsEndCustomerUnitIdMaintenanceIndexRouteImport.update({
    id: '/maintenance/',
    path: '/maintenance/',
    getParentRoute: () => AuthenticatedAccountUnitsEndCustomerUnitIdRouteRoute,
  } as any)
const AuthenticatedAccountUnitsEndCustomerUnitIdPublicationsIndexRoute =
  AuthenticatedAccountUnitsEndCustomerUnitIdPublicationsIndexRouteImport.update(
    {
      id: '/publications/',
      path: '/publications/',
      getParentRoute: () =>
        AuthenticatedAccountUnitsEndCustomerUnitIdRouteRoute,
    } as any,
  )
const AuthenticatedAccountUnitsEndCustomerUnitIdServicesIndexRoute =
  AuthenticatedAccountUnitsEndCustomerUnitIdServicesIndexRouteImport.update({
    id: '/services/',
    path: '/services/',
    getParentRoute: () => AuthenticatedAccountUnitsEndCustomerUnitIdRouteRoute,
  } as any)
const AuthenticatedAccountUnitsEndCustomerUnitIdSettingsIndexRoute =
  AuthenticatedAccountUnitsEndCustomerUnitIdSettingsIndexRouteImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => AuthenticatedAccountUnitsEndCustomerUnitIdRouteRoute,
  } as any)
const AuthenticatedAccountUnitsEndCustomerUnitIdSpecificationsIndexRoute =
  AuthenticatedAccountUnitsEndCustomerUnitIdSpecificationsIndexRouteImport.update(
    {
      id: '/specifications/',
      path: '/specifications/',
      getParentRoute: () =>
        AuthenticatedAccountUnitsEndCustomerUnitIdRouteRoute,
    } as any,
  )
const AuthenticatedAccountFleetsFleetIdDashboardActiveFaultCodesIndexRoute =
  AuthenticatedAccountFleetsFleetIdDashboardActiveFaultCodesIndexRouteImport.update(
    {
      id: '/active-fault-codes/',
      path: '/active-fault-codes/',
      getParentRoute: () =>
        AuthenticatedAccountFleetsFleetIdDashboardRouteRoute,
    } as any,
  )
const AuthenticatedAccountFleetsFleetIdDashboardConnectivityIndexRoute =
  AuthenticatedAccountFleetsFleetIdDashboardConnectivityIndexRouteImport.update(
    {
      id: '/connectivity/',
      path: '/connectivity/',
      getParentRoute: () =>
        AuthenticatedAccountFleetsFleetIdDashboardRouteRoute,
    } as any,
  )
const AuthenticatedAccountFleetsFleetIdDashboardFuelConsumptionIndexRoute =
  AuthenticatedAccountFleetsFleetIdDashboardFuelConsumptionIndexRouteImport.update(
    {
      id: '/fuel-consumption/',
      path: '/fuel-consumption/',
      getParentRoute: () =>
        AuthenticatedAccountFleetsFleetIdDashboardRouteRoute,
    } as any,
  )
const AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdIndexRoute =
  AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdRouteRoute,
    } as any,
  )
const AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdMaintenanceRouteRoute =
  AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdMaintenanceRouteRouteImport.update(
    {
      id: '/maintenance',
      path: '/maintenance',
      getParentRoute: () =>
        AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdRouteRoute,
    } as any,
  )
const AuthenticatedAccountUnitsEndCustomerUnitIdMaintenanceProtocolKeyIndexRoute =
  AuthenticatedAccountUnitsEndCustomerUnitIdMaintenanceProtocolKeyIndexRouteImport.update(
    {
      id: '/maintenance/$protocolKey/',
      path: '/maintenance/$protocolKey/',
      getParentRoute: () =>
        AuthenticatedAccountUnitsEndCustomerUnitIdRouteRoute,
    } as any,
  )
const AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdCampaignsIndexRoute =
  AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdCampaignsIndexRouteImport.update(
    {
      id: '/campaigns/',
      path: '/campaigns/',
      getParentRoute: () =>
        AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdRouteRoute,
    } as any,
  )
const AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdCoverageIndexRoute =
  AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdCoverageIndexRouteImport.update(
    {
      id: '/coverage/',
      path: '/coverage/',
      getParentRoute: () =>
        AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdRouteRoute,
    } as any,
  )
const AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdDiagnosticsIndexRoute =
  AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdDiagnosticsIndexRouteImport.update(
    {
      id: '/diagnostics/',
      path: '/diagnostics/',
      getParentRoute: () =>
        AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdRouteRoute,
    } as any,
  )
const AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdMaintenanceIndexRoute =
  AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdMaintenanceIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdMaintenanceRouteRoute,
    } as any,
  )
const AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdPublicationsIndexRoute =
  AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdPublicationsIndexRouteImport.update(
    {
      id: '/publications/',
      path: '/publications/',
      getParentRoute: () =>
        AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdRouteRoute,
    } as any,
  )
const AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdServicesIndexRoute =
  AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdServicesIndexRouteImport.update(
    {
      id: '/services/',
      path: '/services/',
      getParentRoute: () =>
        AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdRouteRoute,
    } as any,
  )
const AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdSettingsIndexRoute =
  AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdSettingsIndexRouteImport.update(
    {
      id: '/settings/',
      path: '/settings/',
      getParentRoute: () =>
        AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdRouteRoute,
    } as any,
  )
const AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdSpecificationsIndexRoute =
  AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdSpecificationsIndexRouteImport.update(
    {
      id: '/specifications/',
      path: '/specifications/',
      getParentRoute: () =>
        AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdRouteRoute,
    } as any,
  )
const AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdMaintenanceProtocolKeyIndexRoute =
  AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdMaintenanceProtocolKeyIndexRouteImport.update(
    {
      id: '/$protocolKey/',
      path: '/$protocolKey/',
      getParentRoute: () =>
        AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdMaintenanceRouteRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/select-fleet': typeof AuthenticatedSelectFleetRoute
  '/dashboard': typeof AuthenticatedAccountDashboardRouteRouteWithChildren
  '/invite/$inviteId': typeof AuthenticatedInviteInviteIdRouteRoute
  '/settings/': typeof AuthenticatedSettingsIndexRoute
  '/support/': typeof AuthenticatedSupportIndexRoute
  '/welcome/': typeof AuthenticatedWelcomeIndexRoute
  '/faq/': typeof PublicFaqIndexRoute
  '/login/': typeof PublicLoginIndexRoute
  '/fleets/$fleetId': typeof AuthenticatedAccountFleetsFleetIdRouteRouteWithChildren
  '/units/$endCustomerUnitId': typeof AuthenticatedAccountUnitsEndCustomerUnitIdRouteRouteWithChildren
  '/campaigns/': typeof AuthenticatedAccountCampaignsIndexRoute
  '/dashboard/': typeof AuthenticatedAccountDashboardIndexRoute
  '/fleets/': typeof AuthenticatedAccountFleetsIndexRoute
  '/members/': typeof AuthenticatedAccountMembersIndexRoute
  '/units/': typeof AuthenticatedAccountUnitsIndexRoute
  '/fleets/$fleetId/dashboard': typeof AuthenticatedAccountFleetsFleetIdDashboardRouteRouteWithChildren
  '/dashboard/active-fault-codes/': typeof AuthenticatedAccountDashboardActiveFaultCodesIndexRoute
  '/dashboard/connectivity/': typeof AuthenticatedAccountDashboardConnectivityIndexRoute
  '/dashboard/fuel-consumption/': typeof AuthenticatedAccountDashboardFuelConsumptionIndexRoute
  '/members/$endUserId/': typeof AuthenticatedAccountMembersEndUserIdIndexRoute
  '/units/$endCustomerUnitId/': typeof AuthenticatedAccountUnitsEndCustomerUnitIdIndexRoute
  '/fleets/$fleetId/units/$endCustomerUnitId': typeof AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdRouteRouteWithChildren
  '/fleets/$fleetId/campaigns/': typeof AuthenticatedAccountFleetsFleetIdCampaignsIndexRoute
  '/fleets/$fleetId/dashboard/': typeof AuthenticatedAccountFleetsFleetIdDashboardIndexRoute
  '/fleets/$fleetId/units/': typeof AuthenticatedAccountFleetsFleetIdUnitsIndexRoute
  '/units/$endCustomerUnitId/campaigns/': typeof AuthenticatedAccountUnitsEndCustomerUnitIdCampaignsIndexRoute
  '/units/$endCustomerUnitId/coverage/': typeof AuthenticatedAccountUnitsEndCustomerUnitIdCoverageIndexRoute
  '/units/$endCustomerUnitId/diagnostics/': typeof AuthenticatedAccountUnitsEndCustomerUnitIdDiagnosticsIndexRoute
  '/units/$endCustomerUnitId/maintenance/': typeof AuthenticatedAccountUnitsEndCustomerUnitIdMaintenanceIndexRoute
  '/units/$endCustomerUnitId/publications/': typeof AuthenticatedAccountUnitsEndCustomerUnitIdPublicationsIndexRoute
  '/units/$endCustomerUnitId/services/': typeof AuthenticatedAccountUnitsEndCustomerUnitIdServicesIndexRoute
  '/units/$endCustomerUnitId/settings/': typeof AuthenticatedAccountUnitsEndCustomerUnitIdSettingsIndexRoute
  '/units/$endCustomerUnitId/specifications/': typeof AuthenticatedAccountUnitsEndCustomerUnitIdSpecificationsIndexRoute
  '/fleets/$fleetId/units/$endCustomerUnitId/maintenance': typeof AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdMaintenanceRouteRouteWithChildren
  '/fleets/$fleetId/dashboard/active-fault-codes/': typeof AuthenticatedAccountFleetsFleetIdDashboardActiveFaultCodesIndexRoute
  '/fleets/$fleetId/dashboard/connectivity/': typeof AuthenticatedAccountFleetsFleetIdDashboardConnectivityIndexRoute
  '/fleets/$fleetId/dashboard/fuel-consumption/': typeof AuthenticatedAccountFleetsFleetIdDashboardFuelConsumptionIndexRoute
  '/fleets/$fleetId/units/$endCustomerUnitId/': typeof AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdIndexRoute
  '/units/$endCustomerUnitId/maintenance/$protocolKey/': typeof AuthenticatedAccountUnitsEndCustomerUnitIdMaintenanceProtocolKeyIndexRoute
  '/fleets/$fleetId/units/$endCustomerUnitId/campaigns/': typeof AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdCampaignsIndexRoute
  '/fleets/$fleetId/units/$endCustomerUnitId/coverage/': typeof AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdCoverageIndexRoute
  '/fleets/$fleetId/units/$endCustomerUnitId/diagnostics/': typeof AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdDiagnosticsIndexRoute
  '/fleets/$fleetId/units/$endCustomerUnitId/maintenance/': typeof AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdMaintenanceIndexRoute
  '/fleets/$fleetId/units/$endCustomerUnitId/publications/': typeof AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdPublicationsIndexRoute
  '/fleets/$fleetId/units/$endCustomerUnitId/services/': typeof AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdServicesIndexRoute
  '/fleets/$fleetId/units/$endCustomerUnitId/settings/': typeof AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdSettingsIndexRoute
  '/fleets/$fleetId/units/$endCustomerUnitId/specifications/': typeof AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdSpecificationsIndexRoute
  '/fleets/$fleetId/units/$endCustomerUnitId/maintenance/$protocolKey/': typeof AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdMaintenanceProtocolKeyIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/select-fleet': typeof AuthenticatedSelectFleetRoute
  '/invite/$inviteId': typeof AuthenticatedInviteInviteIdRouteRoute
  '/settings': typeof AuthenticatedSettingsIndexRoute
  '/support': typeof AuthenticatedSupportIndexRoute
  '/welcome': typeof AuthenticatedWelcomeIndexRoute
  '/faq': typeof PublicFaqIndexRoute
  '/login': typeof PublicLoginIndexRoute
  '/fleets/$fleetId': typeof AuthenticatedAccountFleetsFleetIdRouteRouteWithChildren
  '/campaigns': typeof AuthenticatedAccountCampaignsIndexRoute
  '/dashboard': typeof AuthenticatedAccountDashboardIndexRoute
  '/fleets': typeof AuthenticatedAccountFleetsIndexRoute
  '/members': typeof AuthenticatedAccountMembersIndexRoute
  '/units': typeof AuthenticatedAccountUnitsIndexRoute
  '/dashboard/active-fault-codes': typeof AuthenticatedAccountDashboardActiveFaultCodesIndexRoute
  '/dashboard/connectivity': typeof AuthenticatedAccountDashboardConnectivityIndexRoute
  '/dashboard/fuel-consumption': typeof AuthenticatedAccountDashboardFuelConsumptionIndexRoute
  '/members/$endUserId': typeof AuthenticatedAccountMembersEndUserIdIndexRoute
  '/units/$endCustomerUnitId': typeof AuthenticatedAccountUnitsEndCustomerUnitIdIndexRoute
  '/fleets/$fleetId/campaigns': typeof AuthenticatedAccountFleetsFleetIdCampaignsIndexRoute
  '/fleets/$fleetId/dashboard': typeof AuthenticatedAccountFleetsFleetIdDashboardIndexRoute
  '/fleets/$fleetId/units': typeof AuthenticatedAccountFleetsFleetIdUnitsIndexRoute
  '/units/$endCustomerUnitId/campaigns': typeof AuthenticatedAccountUnitsEndCustomerUnitIdCampaignsIndexRoute
  '/units/$endCustomerUnitId/coverage': typeof AuthenticatedAccountUnitsEndCustomerUnitIdCoverageIndexRoute
  '/units/$endCustomerUnitId/diagnostics': typeof AuthenticatedAccountUnitsEndCustomerUnitIdDiagnosticsIndexRoute
  '/units/$endCustomerUnitId/maintenance': typeof AuthenticatedAccountUnitsEndCustomerUnitIdMaintenanceIndexRoute
  '/units/$endCustomerUnitId/publications': typeof AuthenticatedAccountUnitsEndCustomerUnitIdPublicationsIndexRoute
  '/units/$endCustomerUnitId/services': typeof AuthenticatedAccountUnitsEndCustomerUnitIdServicesIndexRoute
  '/units/$endCustomerUnitId/settings': typeof AuthenticatedAccountUnitsEndCustomerUnitIdSettingsIndexRoute
  '/units/$endCustomerUnitId/specifications': typeof AuthenticatedAccountUnitsEndCustomerUnitIdSpecificationsIndexRoute
  '/fleets/$fleetId/dashboard/active-fault-codes': typeof AuthenticatedAccountFleetsFleetIdDashboardActiveFaultCodesIndexRoute
  '/fleets/$fleetId/dashboard/connectivity': typeof AuthenticatedAccountFleetsFleetIdDashboardConnectivityIndexRoute
  '/fleets/$fleetId/dashboard/fuel-consumption': typeof AuthenticatedAccountFleetsFleetIdDashboardFuelConsumptionIndexRoute
  '/fleets/$fleetId/units/$endCustomerUnitId': typeof AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdIndexRoute
  '/units/$endCustomerUnitId/maintenance/$protocolKey': typeof AuthenticatedAccountUnitsEndCustomerUnitIdMaintenanceProtocolKeyIndexRoute
  '/fleets/$fleetId/units/$endCustomerUnitId/campaigns': typeof AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdCampaignsIndexRoute
  '/fleets/$fleetId/units/$endCustomerUnitId/coverage': typeof AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdCoverageIndexRoute
  '/fleets/$fleetId/units/$endCustomerUnitId/diagnostics': typeof AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdDiagnosticsIndexRoute
  '/fleets/$fleetId/units/$endCustomerUnitId/maintenance': typeof AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdMaintenanceIndexRoute
  '/fleets/$fleetId/units/$endCustomerUnitId/publications': typeof AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdPublicationsIndexRoute
  '/fleets/$fleetId/units/$endCustomerUnitId/services': typeof AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdServicesIndexRoute
  '/fleets/$fleetId/units/$endCustomerUnitId/settings': typeof AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdSettingsIndexRoute
  '/fleets/$fleetId/units/$endCustomerUnitId/specifications': typeof AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdSpecificationsIndexRoute
  '/fleets/$fleetId/units/$endCustomerUnitId/maintenance/$protocolKey': typeof AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdMaintenanceProtocolKeyIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/_public': typeof PublicRouteRouteWithChildren
  '/_authenticated/_account': typeof AuthenticatedAccountRouteRouteWithChildren
  '/_authenticated/select-fleet': typeof AuthenticatedSelectFleetRoute
  '/_authenticated/_account/dashboard': typeof AuthenticatedAccountDashboardRouteRouteWithChildren
  '/_authenticated/invite/$inviteId': typeof AuthenticatedInviteInviteIdRouteRoute
  '/_authenticated/settings/': typeof AuthenticatedSettingsIndexRoute
  '/_authenticated/support/': typeof AuthenticatedSupportIndexRoute
  '/_authenticated/welcome/': typeof AuthenticatedWelcomeIndexRoute
  '/_public/faq/': typeof PublicFaqIndexRoute
  '/_public/login/': typeof PublicLoginIndexRoute
  '/_authenticated/_account/fleets/$fleetId': typeof AuthenticatedAccountFleetsFleetIdRouteRouteWithChildren
  '/_authenticated/_account/units/$endCustomerUnitId': typeof AuthenticatedAccountUnitsEndCustomerUnitIdRouteRouteWithChildren
  '/_authenticated/_account/campaigns/': typeof AuthenticatedAccountCampaignsIndexRoute
  '/_authenticated/_account/dashboard/': typeof AuthenticatedAccountDashboardIndexRoute
  '/_authenticated/_account/fleets/': typeof AuthenticatedAccountFleetsIndexRoute
  '/_authenticated/_account/members/': typeof AuthenticatedAccountMembersIndexRoute
  '/_authenticated/_account/units/': typeof AuthenticatedAccountUnitsIndexRoute
  '/_authenticated/_account/fleets/$fleetId/dashboard': typeof AuthenticatedAccountFleetsFleetIdDashboardRouteRouteWithChildren
  '/_authenticated/_account/dashboard/active-fault-codes/': typeof AuthenticatedAccountDashboardActiveFaultCodesIndexRoute
  '/_authenticated/_account/dashboard/connectivity/': typeof AuthenticatedAccountDashboardConnectivityIndexRoute
  '/_authenticated/_account/dashboard/fuel-consumption/': typeof AuthenticatedAccountDashboardFuelConsumptionIndexRoute
  '/_authenticated/_account/members/$endUserId/': typeof AuthenticatedAccountMembersEndUserIdIndexRoute
  '/_authenticated/_account/units/$endCustomerUnitId/': typeof AuthenticatedAccountUnitsEndCustomerUnitIdIndexRoute
  '/_authenticated/_account/fleets/$fleetId/units/$endCustomerUnitId': typeof AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdRouteRouteWithChildren
  '/_authenticated/_account/fleets/$fleetId/campaigns/': typeof AuthenticatedAccountFleetsFleetIdCampaignsIndexRoute
  '/_authenticated/_account/fleets/$fleetId/dashboard/': typeof AuthenticatedAccountFleetsFleetIdDashboardIndexRoute
  '/_authenticated/_account/fleets/$fleetId/units/': typeof AuthenticatedAccountFleetsFleetIdUnitsIndexRoute
  '/_authenticated/_account/units/$endCustomerUnitId/campaigns/': typeof AuthenticatedAccountUnitsEndCustomerUnitIdCampaignsIndexRoute
  '/_authenticated/_account/units/$endCustomerUnitId/coverage/': typeof AuthenticatedAccountUnitsEndCustomerUnitIdCoverageIndexRoute
  '/_authenticated/_account/units/$endCustomerUnitId/diagnostics/': typeof AuthenticatedAccountUnitsEndCustomerUnitIdDiagnosticsIndexRoute
  '/_authenticated/_account/units/$endCustomerUnitId/maintenance/': typeof AuthenticatedAccountUnitsEndCustomerUnitIdMaintenanceIndexRoute
  '/_authenticated/_account/units/$endCustomerUnitId/publications/': typeof AuthenticatedAccountUnitsEndCustomerUnitIdPublicationsIndexRoute
  '/_authenticated/_account/units/$endCustomerUnitId/services/': typeof AuthenticatedAccountUnitsEndCustomerUnitIdServicesIndexRoute
  '/_authenticated/_account/units/$endCustomerUnitId/settings/': typeof AuthenticatedAccountUnitsEndCustomerUnitIdSettingsIndexRoute
  '/_authenticated/_account/units/$endCustomerUnitId/specifications/': typeof AuthenticatedAccountUnitsEndCustomerUnitIdSpecificationsIndexRoute
  '/_authenticated/_account/fleets/$fleetId/units/$endCustomerUnitId/maintenance': typeof AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdMaintenanceRouteRouteWithChildren
  '/_authenticated/_account/fleets/$fleetId/dashboard/active-fault-codes/': typeof AuthenticatedAccountFleetsFleetIdDashboardActiveFaultCodesIndexRoute
  '/_authenticated/_account/fleets/$fleetId/dashboard/connectivity/': typeof AuthenticatedAccountFleetsFleetIdDashboardConnectivityIndexRoute
  '/_authenticated/_account/fleets/$fleetId/dashboard/fuel-consumption/': typeof AuthenticatedAccountFleetsFleetIdDashboardFuelConsumptionIndexRoute
  '/_authenticated/_account/fleets/$fleetId/units/$endCustomerUnitId/': typeof AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdIndexRoute
  '/_authenticated/_account/units/$endCustomerUnitId/maintenance/$protocolKey/': typeof AuthenticatedAccountUnitsEndCustomerUnitIdMaintenanceProtocolKeyIndexRoute
  '/_authenticated/_account/fleets/$fleetId/units/$endCustomerUnitId/campaigns/': typeof AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdCampaignsIndexRoute
  '/_authenticated/_account/fleets/$fleetId/units/$endCustomerUnitId/coverage/': typeof AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdCoverageIndexRoute
  '/_authenticated/_account/fleets/$fleetId/units/$endCustomerUnitId/diagnostics/': typeof AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdDiagnosticsIndexRoute
  '/_authenticated/_account/fleets/$fleetId/units/$endCustomerUnitId/maintenance/': typeof AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdMaintenanceIndexRoute
  '/_authenticated/_account/fleets/$fleetId/units/$endCustomerUnitId/publications/': typeof AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdPublicationsIndexRoute
  '/_authenticated/_account/fleets/$fleetId/units/$endCustomerUnitId/services/': typeof AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdServicesIndexRoute
  '/_authenticated/_account/fleets/$fleetId/units/$endCustomerUnitId/settings/': typeof AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdSettingsIndexRoute
  '/_authenticated/_account/fleets/$fleetId/units/$endCustomerUnitId/specifications/': typeof AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdSpecificationsIndexRoute
  '/_authenticated/_account/fleets/$fleetId/units/$endCustomerUnitId/maintenance/$protocolKey/': typeof AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdMaintenanceProtocolKeyIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/select-fleet'
    | '/dashboard'
    | '/invite/$inviteId'
    | '/settings/'
    | '/support/'
    | '/welcome/'
    | '/faq/'
    | '/login/'
    | '/fleets/$fleetId'
    | '/units/$endCustomerUnitId'
    | '/campaigns/'
    | '/dashboard/'
    | '/fleets/'
    | '/members/'
    | '/units/'
    | '/fleets/$fleetId/dashboard'
    | '/dashboard/active-fault-codes/'
    | '/dashboard/connectivity/'
    | '/dashboard/fuel-consumption/'
    | '/members/$endUserId/'
    | '/units/$endCustomerUnitId/'
    | '/fleets/$fleetId/units/$endCustomerUnitId'
    | '/fleets/$fleetId/campaigns/'
    | '/fleets/$fleetId/dashboard/'
    | '/fleets/$fleetId/units/'
    | '/units/$endCustomerUnitId/campaigns/'
    | '/units/$endCustomerUnitId/coverage/'
    | '/units/$endCustomerUnitId/diagnostics/'
    | '/units/$endCustomerUnitId/maintenance/'
    | '/units/$endCustomerUnitId/publications/'
    | '/units/$endCustomerUnitId/services/'
    | '/units/$endCustomerUnitId/settings/'
    | '/units/$endCustomerUnitId/specifications/'
    | '/fleets/$fleetId/units/$endCustomerUnitId/maintenance'
    | '/fleets/$fleetId/dashboard/active-fault-codes/'
    | '/fleets/$fleetId/dashboard/connectivity/'
    | '/fleets/$fleetId/dashboard/fuel-consumption/'
    | '/fleets/$fleetId/units/$endCustomerUnitId/'
    | '/units/$endCustomerUnitId/maintenance/$protocolKey/'
    | '/fleets/$fleetId/units/$endCustomerUnitId/campaigns/'
    | '/fleets/$fleetId/units/$endCustomerUnitId/coverage/'
    | '/fleets/$fleetId/units/$endCustomerUnitId/diagnostics/'
    | '/fleets/$fleetId/units/$endCustomerUnitId/maintenance/'
    | '/fleets/$fleetId/units/$endCustomerUnitId/publications/'
    | '/fleets/$fleetId/units/$endCustomerUnitId/services/'
    | '/fleets/$fleetId/units/$endCustomerUnitId/settings/'
    | '/fleets/$fleetId/units/$endCustomerUnitId/specifications/'
    | '/fleets/$fleetId/units/$endCustomerUnitId/maintenance/$protocolKey/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/select-fleet'
    | '/invite/$inviteId'
    | '/settings'
    | '/support'
    | '/welcome'
    | '/faq'
    | '/login'
    | '/fleets/$fleetId'
    | '/campaigns'
    | '/dashboard'
    | '/fleets'
    | '/members'
    | '/units'
    | '/dashboard/active-fault-codes'
    | '/dashboard/connectivity'
    | '/dashboard/fuel-consumption'
    | '/members/$endUserId'
    | '/units/$endCustomerUnitId'
    | '/fleets/$fleetId/campaigns'
    | '/fleets/$fleetId/dashboard'
    | '/fleets/$fleetId/units'
    | '/units/$endCustomerUnitId/campaigns'
    | '/units/$endCustomerUnitId/coverage'
    | '/units/$endCustomerUnitId/diagnostics'
    | '/units/$endCustomerUnitId/maintenance'
    | '/units/$endCustomerUnitId/publications'
    | '/units/$endCustomerUnitId/services'
    | '/units/$endCustomerUnitId/settings'
    | '/units/$endCustomerUnitId/specifications'
    | '/fleets/$fleetId/dashboard/active-fault-codes'
    | '/fleets/$fleetId/dashboard/connectivity'
    | '/fleets/$fleetId/dashboard/fuel-consumption'
    | '/fleets/$fleetId/units/$endCustomerUnitId'
    | '/units/$endCustomerUnitId/maintenance/$protocolKey'
    | '/fleets/$fleetId/units/$endCustomerUnitId/campaigns'
    | '/fleets/$fleetId/units/$endCustomerUnitId/coverage'
    | '/fleets/$fleetId/units/$endCustomerUnitId/diagnostics'
    | '/fleets/$fleetId/units/$endCustomerUnitId/maintenance'
    | '/fleets/$fleetId/units/$endCustomerUnitId/publications'
    | '/fleets/$fleetId/units/$endCustomerUnitId/services'
    | '/fleets/$fleetId/units/$endCustomerUnitId/settings'
    | '/fleets/$fleetId/units/$endCustomerUnitId/specifications'
    | '/fleets/$fleetId/units/$endCustomerUnitId/maintenance/$protocolKey'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/_public'
    | '/_authenticated/_account'
    | '/_authenticated/select-fleet'
    | '/_authenticated/_account/dashboard'
    | '/_authenticated/invite/$inviteId'
    | '/_authenticated/settings/'
    | '/_authenticated/support/'
    | '/_authenticated/welcome/'
    | '/_public/faq/'
    | '/_public/login/'
    | '/_authenticated/_account/fleets/$fleetId'
    | '/_authenticated/_account/units/$endCustomerUnitId'
    | '/_authenticated/_account/campaigns/'
    | '/_authenticated/_account/dashboard/'
    | '/_authenticated/_account/fleets/'
    | '/_authenticated/_account/members/'
    | '/_authenticated/_account/units/'
    | '/_authenticated/_account/fleets/$fleetId/dashboard'
    | '/_authenticated/_account/dashboard/active-fault-codes/'
    | '/_authenticated/_account/dashboard/connectivity/'
    | '/_authenticated/_account/dashboard/fuel-consumption/'
    | '/_authenticated/_account/members/$endUserId/'
    | '/_authenticated/_account/units/$endCustomerUnitId/'
    | '/_authenticated/_account/fleets/$fleetId/units/$endCustomerUnitId'
    | '/_authenticated/_account/fleets/$fleetId/campaigns/'
    | '/_authenticated/_account/fleets/$fleetId/dashboard/'
    | '/_authenticated/_account/fleets/$fleetId/units/'
    | '/_authenticated/_account/units/$endCustomerUnitId/campaigns/'
    | '/_authenticated/_account/units/$endCustomerUnitId/coverage/'
    | '/_authenticated/_account/units/$endCustomerUnitId/diagnostics/'
    | '/_authenticated/_account/units/$endCustomerUnitId/maintenance/'
    | '/_authenticated/_account/units/$endCustomerUnitId/publications/'
    | '/_authenticated/_account/units/$endCustomerUnitId/services/'
    | '/_authenticated/_account/units/$endCustomerUnitId/settings/'
    | '/_authenticated/_account/units/$endCustomerUnitId/specifications/'
    | '/_authenticated/_account/fleets/$fleetId/units/$endCustomerUnitId/maintenance'
    | '/_authenticated/_account/fleets/$fleetId/dashboard/active-fault-codes/'
    | '/_authenticated/_account/fleets/$fleetId/dashboard/connectivity/'
    | '/_authenticated/_account/fleets/$fleetId/dashboard/fuel-consumption/'
    | '/_authenticated/_account/fleets/$fleetId/units/$endCustomerUnitId/'
    | '/_authenticated/_account/units/$endCustomerUnitId/maintenance/$protocolKey/'
    | '/_authenticated/_account/fleets/$fleetId/units/$endCustomerUnitId/campaigns/'
    | '/_authenticated/_account/fleets/$fleetId/units/$endCustomerUnitId/coverage/'
    | '/_authenticated/_account/fleets/$fleetId/units/$endCustomerUnitId/diagnostics/'
    | '/_authenticated/_account/fleets/$fleetId/units/$endCustomerUnitId/maintenance/'
    | '/_authenticated/_account/fleets/$fleetId/units/$endCustomerUnitId/publications/'
    | '/_authenticated/_account/fleets/$fleetId/units/$endCustomerUnitId/services/'
    | '/_authenticated/_account/fleets/$fleetId/units/$endCustomerUnitId/settings/'
    | '/_authenticated/_account/fleets/$fleetId/units/$endCustomerUnitId/specifications/'
    | '/_authenticated/_account/fleets/$fleetId/units/$endCustomerUnitId/maintenance/$protocolKey/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  PublicRouteRoute: typeof PublicRouteRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PublicRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/_account': {
      id: '/_authenticated/_account'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedAccountRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/select-fleet': {
      id: '/_authenticated/select-fleet'
      path: '/select-fleet'
      fullPath: '/select-fleet'
      preLoaderRoute: typeof AuthenticatedSelectFleetRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/_account/dashboard': {
      id: '/_authenticated/_account/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticatedAccountDashboardRouteRouteImport
      parentRoute: typeof AuthenticatedAccountRouteRoute
    }
    '/_authenticated/invite/$inviteId': {
      id: '/_authenticated/invite/$inviteId'
      path: '/invite/$inviteId'
      fullPath: '/invite/$inviteId'
      preLoaderRoute: typeof AuthenticatedInviteInviteIdRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/settings/': {
      id: '/_authenticated/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthenticatedSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/support/': {
      id: '/_authenticated/support/'
      path: '/support'
      fullPath: '/support/'
      preLoaderRoute: typeof AuthenticatedSupportIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/welcome/': {
      id: '/_authenticated/welcome/'
      path: '/welcome'
      fullPath: '/welcome/'
      preLoaderRoute: typeof AuthenticatedWelcomeIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_public/faq/': {
      id: '/_public/faq/'
      path: '/faq'
      fullPath: '/faq/'
      preLoaderRoute: typeof PublicFaqIndexRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/_public/login/': {
      id: '/_public/login/'
      path: '/login'
      fullPath: '/login/'
      preLoaderRoute: typeof PublicLoginIndexRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/_authenticated/_account/campaigns/': {
      id: '/_authenticated/_account/campaigns/'
      path: '/campaigns'
      fullPath: '/campaigns/'
      preLoaderRoute: typeof AuthenticatedAccountCampaignsIndexRouteImport
      parentRoute: typeof AuthenticatedAccountRouteRoute
    }
    '/_authenticated/_account/dashboard/': {
      id: '/_authenticated/_account/dashboard/'
      path: '/'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof AuthenticatedAccountDashboardIndexRouteImport
      parentRoute: typeof AuthenticatedAccountDashboardRouteRoute
    }
    '/_authenticated/_account/fleets/': {
      id: '/_authenticated/_account/fleets/'
      path: '/fleets'
      fullPath: '/fleets/'
      preLoaderRoute: typeof AuthenticatedAccountFleetsIndexRouteImport
      parentRoute: typeof AuthenticatedAccountRouteRoute
    }
    '/_authenticated/_account/fleets/$fleetId': {
      id: '/_authenticated/_account/fleets/$fleetId'
      path: '/fleets/$fleetId'
      fullPath: '/fleets/$fleetId'
      preLoaderRoute: typeof AuthenticatedAccountFleetsFleetIdRouteRouteImport
      parentRoute: typeof AuthenticatedAccountRouteRoute
    }
    '/_authenticated/_account/members/': {
      id: '/_authenticated/_account/members/'
      path: '/members'
      fullPath: '/members/'
      preLoaderRoute: typeof AuthenticatedAccountMembersIndexRouteImport
      parentRoute: typeof AuthenticatedAccountRouteRoute
    }
    '/_authenticated/_account/units/': {
      id: '/_authenticated/_account/units/'
      path: '/units'
      fullPath: '/units/'
      preLoaderRoute: typeof AuthenticatedAccountUnitsIndexRouteImport
      parentRoute: typeof AuthenticatedAccountRouteRoute
    }
    '/_authenticated/_account/units/$endCustomerUnitId': {
      id: '/_authenticated/_account/units/$endCustomerUnitId'
      path: '/units/$endCustomerUnitId'
      fullPath: '/units/$endCustomerUnitId'
      preLoaderRoute: typeof AuthenticatedAccountUnitsEndCustomerUnitIdRouteRouteImport
      parentRoute: typeof AuthenticatedAccountRouteRoute
    }
    '/_authenticated/_account/dashboard/active-fault-codes/': {
      id: '/_authenticated/_account/dashboard/active-fault-codes/'
      path: '/active-fault-codes'
      fullPath: '/dashboard/active-fault-codes/'
      preLoaderRoute: typeof AuthenticatedAccountDashboardActiveFaultCodesIndexRouteImport
      parentRoute: typeof AuthenticatedAccountDashboardRouteRoute
    }
    '/_authenticated/_account/dashboard/connectivity/': {
      id: '/_authenticated/_account/dashboard/connectivity/'
      path: '/connectivity'
      fullPath: '/dashboard/connectivity/'
      preLoaderRoute: typeof AuthenticatedAccountDashboardConnectivityIndexRouteImport
      parentRoute: typeof AuthenticatedAccountDashboardRouteRoute
    }
    '/_authenticated/_account/dashboard/fuel-consumption/': {
      id: '/_authenticated/_account/dashboard/fuel-consumption/'
      path: '/fuel-consumption'
      fullPath: '/dashboard/fuel-consumption/'
      preLoaderRoute: typeof AuthenticatedAccountDashboardFuelConsumptionIndexRouteImport
      parentRoute: typeof AuthenticatedAccountDashboardRouteRoute
    }
    '/_authenticated/_account/fleets/$fleetId/dashboard': {
      id: '/_authenticated/_account/fleets/$fleetId/dashboard'
      path: '/dashboard'
      fullPath: '/fleets/$fleetId/dashboard'
      preLoaderRoute: typeof AuthenticatedAccountFleetsFleetIdDashboardRouteRouteImport
      parentRoute: typeof AuthenticatedAccountFleetsFleetIdRouteRoute
    }
    '/_authenticated/_account/members/$endUserId/': {
      id: '/_authenticated/_account/members/$endUserId/'
      path: '/members/$endUserId'
      fullPath: '/members/$endUserId/'
      preLoaderRoute: typeof AuthenticatedAccountMembersEndUserIdIndexRouteImport
      parentRoute: typeof AuthenticatedAccountRouteRoute
    }
    '/_authenticated/_account/units/$endCustomerUnitId/': {
      id: '/_authenticated/_account/units/$endCustomerUnitId/'
      path: '/'
      fullPath: '/units/$endCustomerUnitId/'
      preLoaderRoute: typeof AuthenticatedAccountUnitsEndCustomerUnitIdIndexRouteImport
      parentRoute: typeof AuthenticatedAccountUnitsEndCustomerUnitIdRouteRoute
    }
    '/_authenticated/_account/fleets/$fleetId/campaigns/': {
      id: '/_authenticated/_account/fleets/$fleetId/campaigns/'
      path: '/campaigns'
      fullPath: '/fleets/$fleetId/campaigns/'
      preLoaderRoute: typeof AuthenticatedAccountFleetsFleetIdCampaignsIndexRouteImport
      parentRoute: typeof AuthenticatedAccountFleetsFleetIdRouteRoute
    }
    '/_authenticated/_account/fleets/$fleetId/dashboard/': {
      id: '/_authenticated/_account/fleets/$fleetId/dashboard/'
      path: '/'
      fullPath: '/fleets/$fleetId/dashboard/'
      preLoaderRoute: typeof AuthenticatedAccountFleetsFleetIdDashboardIndexRouteImport
      parentRoute: typeof AuthenticatedAccountFleetsFleetIdDashboardRouteRoute
    }
    '/_authenticated/_account/fleets/$fleetId/units/': {
      id: '/_authenticated/_account/fleets/$fleetId/units/'
      path: '/units'
      fullPath: '/fleets/$fleetId/units/'
      preLoaderRoute: typeof AuthenticatedAccountFleetsFleetIdUnitsIndexRouteImport
      parentRoute: typeof AuthenticatedAccountFleetsFleetIdRouteRoute
    }
    '/_authenticated/_account/fleets/$fleetId/units/$endCustomerUnitId': {
      id: '/_authenticated/_account/fleets/$fleetId/units/$endCustomerUnitId'
      path: '/units/$endCustomerUnitId'
      fullPath: '/fleets/$fleetId/units/$endCustomerUnitId'
      preLoaderRoute: typeof AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdRouteRouteImport
      parentRoute: typeof AuthenticatedAccountFleetsFleetIdRouteRoute
    }
    '/_authenticated/_account/units/$endCustomerUnitId/campaigns/': {
      id: '/_authenticated/_account/units/$endCustomerUnitId/campaigns/'
      path: '/campaigns'
      fullPath: '/units/$endCustomerUnitId/campaigns/'
      preLoaderRoute: typeof AuthenticatedAccountUnitsEndCustomerUnitIdCampaignsIndexRouteImport
      parentRoute: typeof AuthenticatedAccountUnitsEndCustomerUnitIdRouteRoute
    }
    '/_authenticated/_account/units/$endCustomerUnitId/coverage/': {
      id: '/_authenticated/_account/units/$endCustomerUnitId/coverage/'
      path: '/coverage'
      fullPath: '/units/$endCustomerUnitId/coverage/'
      preLoaderRoute: typeof AuthenticatedAccountUnitsEndCustomerUnitIdCoverageIndexRouteImport
      parentRoute: typeof AuthenticatedAccountUnitsEndCustomerUnitIdRouteRoute
    }
    '/_authenticated/_account/units/$endCustomerUnitId/diagnostics/': {
      id: '/_authenticated/_account/units/$endCustomerUnitId/diagnostics/'
      path: '/diagnostics'
      fullPath: '/units/$endCustomerUnitId/diagnostics/'
      preLoaderRoute: typeof AuthenticatedAccountUnitsEndCustomerUnitIdDiagnosticsIndexRouteImport
      parentRoute: typeof AuthenticatedAccountUnitsEndCustomerUnitIdRouteRoute
    }
    '/_authenticated/_account/units/$endCustomerUnitId/maintenance/': {
      id: '/_authenticated/_account/units/$endCustomerUnitId/maintenance/'
      path: '/maintenance'
      fullPath: '/units/$endCustomerUnitId/maintenance/'
      preLoaderRoute: typeof AuthenticatedAccountUnitsEndCustomerUnitIdMaintenanceIndexRouteImport
      parentRoute: typeof AuthenticatedAccountUnitsEndCustomerUnitIdRouteRoute
    }
    '/_authenticated/_account/units/$endCustomerUnitId/publications/': {
      id: '/_authenticated/_account/units/$endCustomerUnitId/publications/'
      path: '/publications'
      fullPath: '/units/$endCustomerUnitId/publications/'
      preLoaderRoute: typeof AuthenticatedAccountUnitsEndCustomerUnitIdPublicationsIndexRouteImport
      parentRoute: typeof AuthenticatedAccountUnitsEndCustomerUnitIdRouteRoute
    }
    '/_authenticated/_account/units/$endCustomerUnitId/services/': {
      id: '/_authenticated/_account/units/$endCustomerUnitId/services/'
      path: '/services'
      fullPath: '/units/$endCustomerUnitId/services/'
      preLoaderRoute: typeof AuthenticatedAccountUnitsEndCustomerUnitIdServicesIndexRouteImport
      parentRoute: typeof AuthenticatedAccountUnitsEndCustomerUnitIdRouteRoute
    }
    '/_authenticated/_account/units/$endCustomerUnitId/settings/': {
      id: '/_authenticated/_account/units/$endCustomerUnitId/settings/'
      path: '/settings'
      fullPath: '/units/$endCustomerUnitId/settings/'
      preLoaderRoute: typeof AuthenticatedAccountUnitsEndCustomerUnitIdSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedAccountUnitsEndCustomerUnitIdRouteRoute
    }
    '/_authenticated/_account/units/$endCustomerUnitId/specifications/': {
      id: '/_authenticated/_account/units/$endCustomerUnitId/specifications/'
      path: '/specifications'
      fullPath: '/units/$endCustomerUnitId/specifications/'
      preLoaderRoute: typeof AuthenticatedAccountUnitsEndCustomerUnitIdSpecificationsIndexRouteImport
      parentRoute: typeof AuthenticatedAccountUnitsEndCustomerUnitIdRouteRoute
    }
    '/_authenticated/_account/fleets/$fleetId/dashboard/active-fault-codes/': {
      id: '/_authenticated/_account/fleets/$fleetId/dashboard/active-fault-codes/'
      path: '/active-fault-codes'
      fullPath: '/fleets/$fleetId/dashboard/active-fault-codes/'
      preLoaderRoute: typeof AuthenticatedAccountFleetsFleetIdDashboardActiveFaultCodesIndexRouteImport
      parentRoute: typeof AuthenticatedAccountFleetsFleetIdDashboardRouteRoute
    }
    '/_authenticated/_account/fleets/$fleetId/dashboard/connectivity/': {
      id: '/_authenticated/_account/fleets/$fleetId/dashboard/connectivity/'
      path: '/connectivity'
      fullPath: '/fleets/$fleetId/dashboard/connectivity/'
      preLoaderRoute: typeof AuthenticatedAccountFleetsFleetIdDashboardConnectivityIndexRouteImport
      parentRoute: typeof AuthenticatedAccountFleetsFleetIdDashboardRouteRoute
    }
    '/_authenticated/_account/fleets/$fleetId/dashboard/fuel-consumption/': {
      id: '/_authenticated/_account/fleets/$fleetId/dashboard/fuel-consumption/'
      path: '/fuel-consumption'
      fullPath: '/fleets/$fleetId/dashboard/fuel-consumption/'
      preLoaderRoute: typeof AuthenticatedAccountFleetsFleetIdDashboardFuelConsumptionIndexRouteImport
      parentRoute: typeof AuthenticatedAccountFleetsFleetIdDashboardRouteRoute
    }
    '/_authenticated/_account/fleets/$fleetId/units/$endCustomerUnitId/': {
      id: '/_authenticated/_account/fleets/$fleetId/units/$endCustomerUnitId/'
      path: '/'
      fullPath: '/fleets/$fleetId/units/$endCustomerUnitId/'
      preLoaderRoute: typeof AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdIndexRouteImport
      parentRoute: typeof AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdRouteRoute
    }
    '/_authenticated/_account/fleets/$fleetId/units/$endCustomerUnitId/maintenance': {
      id: '/_authenticated/_account/fleets/$fleetId/units/$endCustomerUnitId/maintenance'
      path: '/maintenance'
      fullPath: '/fleets/$fleetId/units/$endCustomerUnitId/maintenance'
      preLoaderRoute: typeof AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdMaintenanceRouteRouteImport
      parentRoute: typeof AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdRouteRoute
    }
    '/_authenticated/_account/units/$endCustomerUnitId/maintenance/$protocolKey/': {
      id: '/_authenticated/_account/units/$endCustomerUnitId/maintenance/$protocolKey/'
      path: '/maintenance/$protocolKey'
      fullPath: '/units/$endCustomerUnitId/maintenance/$protocolKey/'
      preLoaderRoute: typeof AuthenticatedAccountUnitsEndCustomerUnitIdMaintenanceProtocolKeyIndexRouteImport
      parentRoute: typeof AuthenticatedAccountUnitsEndCustomerUnitIdRouteRoute
    }
    '/_authenticated/_account/fleets/$fleetId/units/$endCustomerUnitId/campaigns/': {
      id: '/_authenticated/_account/fleets/$fleetId/units/$endCustomerUnitId/campaigns/'
      path: '/campaigns'
      fullPath: '/fleets/$fleetId/units/$endCustomerUnitId/campaigns/'
      preLoaderRoute: typeof AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdCampaignsIndexRouteImport
      parentRoute: typeof AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdRouteRoute
    }
    '/_authenticated/_account/fleets/$fleetId/units/$endCustomerUnitId/coverage/': {
      id: '/_authenticated/_account/fleets/$fleetId/units/$endCustomerUnitId/coverage/'
      path: '/coverage'
      fullPath: '/fleets/$fleetId/units/$endCustomerUnitId/coverage/'
      preLoaderRoute: typeof AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdCoverageIndexRouteImport
      parentRoute: typeof AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdRouteRoute
    }
    '/_authenticated/_account/fleets/$fleetId/units/$endCustomerUnitId/diagnostics/': {
      id: '/_authenticated/_account/fleets/$fleetId/units/$endCustomerUnitId/diagnostics/'
      path: '/diagnostics'
      fullPath: '/fleets/$fleetId/units/$endCustomerUnitId/diagnostics/'
      preLoaderRoute: typeof AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdDiagnosticsIndexRouteImport
      parentRoute: typeof AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdRouteRoute
    }
    '/_authenticated/_account/fleets/$fleetId/units/$endCustomerUnitId/maintenance/': {
      id: '/_authenticated/_account/fleets/$fleetId/units/$endCustomerUnitId/maintenance/'
      path: '/'
      fullPath: '/fleets/$fleetId/units/$endCustomerUnitId/maintenance/'
      preLoaderRoute: typeof AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdMaintenanceIndexRouteImport
      parentRoute: typeof AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdMaintenanceRouteRoute
    }
    '/_authenticated/_account/fleets/$fleetId/units/$endCustomerUnitId/publications/': {
      id: '/_authenticated/_account/fleets/$fleetId/units/$endCustomerUnitId/publications/'
      path: '/publications'
      fullPath: '/fleets/$fleetId/units/$endCustomerUnitId/publications/'
      preLoaderRoute: typeof AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdPublicationsIndexRouteImport
      parentRoute: typeof AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdRouteRoute
    }
    '/_authenticated/_account/fleets/$fleetId/units/$endCustomerUnitId/services/': {
      id: '/_authenticated/_account/fleets/$fleetId/units/$endCustomerUnitId/services/'
      path: '/services'
      fullPath: '/fleets/$fleetId/units/$endCustomerUnitId/services/'
      preLoaderRoute: typeof AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdServicesIndexRouteImport
      parentRoute: typeof AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdRouteRoute
    }
    '/_authenticated/_account/fleets/$fleetId/units/$endCustomerUnitId/settings/': {
      id: '/_authenticated/_account/fleets/$fleetId/units/$endCustomerUnitId/settings/'
      path: '/settings'
      fullPath: '/fleets/$fleetId/units/$endCustomerUnitId/settings/'
      preLoaderRoute: typeof AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdRouteRoute
    }
    '/_authenticated/_account/fleets/$fleetId/units/$endCustomerUnitId/specifications/': {
      id: '/_authenticated/_account/fleets/$fleetId/units/$endCustomerUnitId/specifications/'
      path: '/specifications'
      fullPath: '/fleets/$fleetId/units/$endCustomerUnitId/specifications/'
      preLoaderRoute: typeof AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdSpecificationsIndexRouteImport
      parentRoute: typeof AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdRouteRoute
    }
    '/_authenticated/_account/fleets/$fleetId/units/$endCustomerUnitId/maintenance/$protocolKey/': {
      id: '/_authenticated/_account/fleets/$fleetId/units/$endCustomerUnitId/maintenance/$protocolKey/'
      path: '/$protocolKey'
      fullPath: '/fleets/$fleetId/units/$endCustomerUnitId/maintenance/$protocolKey/'
      preLoaderRoute: typeof AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdMaintenanceProtocolKeyIndexRouteImport
      parentRoute: typeof AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdMaintenanceRouteRoute
    }
  }
}

interface AuthenticatedAccountDashboardRouteRouteChildren {
  AuthenticatedAccountDashboardIndexRoute: typeof AuthenticatedAccountDashboardIndexRoute
  AuthenticatedAccountDashboardActiveFaultCodesIndexRoute: typeof AuthenticatedAccountDashboardActiveFaultCodesIndexRoute
  AuthenticatedAccountDashboardConnectivityIndexRoute: typeof AuthenticatedAccountDashboardConnectivityIndexRoute
  AuthenticatedAccountDashboardFuelConsumptionIndexRoute: typeof AuthenticatedAccountDashboardFuelConsumptionIndexRoute
}

const AuthenticatedAccountDashboardRouteRouteChildren: AuthenticatedAccountDashboardRouteRouteChildren =
  {
    AuthenticatedAccountDashboardIndexRoute:
      AuthenticatedAccountDashboardIndexRoute,
    AuthenticatedAccountDashboardActiveFaultCodesIndexRoute:
      AuthenticatedAccountDashboardActiveFaultCodesIndexRoute,
    AuthenticatedAccountDashboardConnectivityIndexRoute:
      AuthenticatedAccountDashboardConnectivityIndexRoute,
    AuthenticatedAccountDashboardFuelConsumptionIndexRoute:
      AuthenticatedAccountDashboardFuelConsumptionIndexRoute,
  }

const AuthenticatedAccountDashboardRouteRouteWithChildren =
  AuthenticatedAccountDashboardRouteRoute._addFileChildren(
    AuthenticatedAccountDashboardRouteRouteChildren,
  )

interface AuthenticatedAccountFleetsFleetIdDashboardRouteRouteChildren {
  AuthenticatedAccountFleetsFleetIdDashboardIndexRoute: typeof AuthenticatedAccountFleetsFleetIdDashboardIndexRoute
  AuthenticatedAccountFleetsFleetIdDashboardActiveFaultCodesIndexRoute: typeof AuthenticatedAccountFleetsFleetIdDashboardActiveFaultCodesIndexRoute
  AuthenticatedAccountFleetsFleetIdDashboardConnectivityIndexRoute: typeof AuthenticatedAccountFleetsFleetIdDashboardConnectivityIndexRoute
  AuthenticatedAccountFleetsFleetIdDashboardFuelConsumptionIndexRoute: typeof AuthenticatedAccountFleetsFleetIdDashboardFuelConsumptionIndexRoute
}

const AuthenticatedAccountFleetsFleetIdDashboardRouteRouteChildren: AuthenticatedAccountFleetsFleetIdDashboardRouteRouteChildren =
  {
    AuthenticatedAccountFleetsFleetIdDashboardIndexRoute:
      AuthenticatedAccountFleetsFleetIdDashboardIndexRoute,
    AuthenticatedAccountFleetsFleetIdDashboardActiveFaultCodesIndexRoute:
      AuthenticatedAccountFleetsFleetIdDashboardActiveFaultCodesIndexRoute,
    AuthenticatedAccountFleetsFleetIdDashboardConnectivityIndexRoute:
      AuthenticatedAccountFleetsFleetIdDashboardConnectivityIndexRoute,
    AuthenticatedAccountFleetsFleetIdDashboardFuelConsumptionIndexRoute:
      AuthenticatedAccountFleetsFleetIdDashboardFuelConsumptionIndexRoute,
  }

const AuthenticatedAccountFleetsFleetIdDashboardRouteRouteWithChildren =
  AuthenticatedAccountFleetsFleetIdDashboardRouteRoute._addFileChildren(
    AuthenticatedAccountFleetsFleetIdDashboardRouteRouteChildren,
  )

interface AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdMaintenanceRouteRouteChildren {
  AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdMaintenanceIndexRoute: typeof AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdMaintenanceIndexRoute
  AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdMaintenanceProtocolKeyIndexRoute: typeof AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdMaintenanceProtocolKeyIndexRoute
}

const AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdMaintenanceRouteRouteChildren: AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdMaintenanceRouteRouteChildren =
  {
    AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdMaintenanceIndexRoute:
      AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdMaintenanceIndexRoute,
    AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdMaintenanceProtocolKeyIndexRoute:
      AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdMaintenanceProtocolKeyIndexRoute,
  }

const AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdMaintenanceRouteRouteWithChildren =
  AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdMaintenanceRouteRoute._addFileChildren(
    AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdMaintenanceRouteRouteChildren,
  )

interface AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdRouteRouteChildren {
  AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdMaintenanceRouteRoute: typeof AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdMaintenanceRouteRouteWithChildren
  AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdIndexRoute: typeof AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdIndexRoute
  AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdCampaignsIndexRoute: typeof AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdCampaignsIndexRoute
  AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdCoverageIndexRoute: typeof AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdCoverageIndexRoute
  AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdDiagnosticsIndexRoute: typeof AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdDiagnosticsIndexRoute
  AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdPublicationsIndexRoute: typeof AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdPublicationsIndexRoute
  AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdServicesIndexRoute: typeof AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdServicesIndexRoute
  AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdSettingsIndexRoute: typeof AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdSettingsIndexRoute
  AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdSpecificationsIndexRoute: typeof AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdSpecificationsIndexRoute
}

const AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdRouteRouteChildren: AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdRouteRouteChildren =
  {
    AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdMaintenanceRouteRoute:
      AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdMaintenanceRouteRouteWithChildren,
    AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdIndexRoute:
      AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdIndexRoute,
    AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdCampaignsIndexRoute:
      AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdCampaignsIndexRoute,
    AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdCoverageIndexRoute:
      AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdCoverageIndexRoute,
    AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdDiagnosticsIndexRoute:
      AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdDiagnosticsIndexRoute,
    AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdPublicationsIndexRoute:
      AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdPublicationsIndexRoute,
    AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdServicesIndexRoute:
      AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdServicesIndexRoute,
    AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdSettingsIndexRoute:
      AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdSettingsIndexRoute,
    AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdSpecificationsIndexRoute:
      AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdSpecificationsIndexRoute,
  }

const AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdRouteRouteWithChildren =
  AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdRouteRoute._addFileChildren(
    AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdRouteRouteChildren,
  )

interface AuthenticatedAccountFleetsFleetIdRouteRouteChildren {
  AuthenticatedAccountFleetsFleetIdDashboardRouteRoute: typeof AuthenticatedAccountFleetsFleetIdDashboardRouteRouteWithChildren
  AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdRouteRoute: typeof AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdRouteRouteWithChildren
  AuthenticatedAccountFleetsFleetIdCampaignsIndexRoute: typeof AuthenticatedAccountFleetsFleetIdCampaignsIndexRoute
  AuthenticatedAccountFleetsFleetIdUnitsIndexRoute: typeof AuthenticatedAccountFleetsFleetIdUnitsIndexRoute
}

const AuthenticatedAccountFleetsFleetIdRouteRouteChildren: AuthenticatedAccountFleetsFleetIdRouteRouteChildren =
  {
    AuthenticatedAccountFleetsFleetIdDashboardRouteRoute:
      AuthenticatedAccountFleetsFleetIdDashboardRouteRouteWithChildren,
    AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdRouteRoute:
      AuthenticatedAccountFleetsFleetIdUnitsEndCustomerUnitIdRouteRouteWithChildren,
    AuthenticatedAccountFleetsFleetIdCampaignsIndexRoute:
      AuthenticatedAccountFleetsFleetIdCampaignsIndexRoute,
    AuthenticatedAccountFleetsFleetIdUnitsIndexRoute:
      AuthenticatedAccountFleetsFleetIdUnitsIndexRoute,
  }

const AuthenticatedAccountFleetsFleetIdRouteRouteWithChildren =
  AuthenticatedAccountFleetsFleetIdRouteRoute._addFileChildren(
    AuthenticatedAccountFleetsFleetIdRouteRouteChildren,
  )

interface AuthenticatedAccountUnitsEndCustomerUnitIdRouteRouteChildren {
  AuthenticatedAccountUnitsEndCustomerUnitIdIndexRoute: typeof AuthenticatedAccountUnitsEndCustomerUnitIdIndexRoute
  AuthenticatedAccountUnitsEndCustomerUnitIdCampaignsIndexRoute: typeof AuthenticatedAccountUnitsEndCustomerUnitIdCampaignsIndexRoute
  AuthenticatedAccountUnitsEndCustomerUnitIdCoverageIndexRoute: typeof AuthenticatedAccountUnitsEndCustomerUnitIdCoverageIndexRoute
  AuthenticatedAccountUnitsEndCustomerUnitIdDiagnosticsIndexRoute: typeof AuthenticatedAccountUnitsEndCustomerUnitIdDiagnosticsIndexRoute
  AuthenticatedAccountUnitsEndCustomerUnitIdMaintenanceIndexRoute: typeof AuthenticatedAccountUnitsEndCustomerUnitIdMaintenanceIndexRoute
  AuthenticatedAccountUnitsEndCustomerUnitIdPublicationsIndexRoute: typeof AuthenticatedAccountUnitsEndCustomerUnitIdPublicationsIndexRoute
  AuthenticatedAccountUnitsEndCustomerUnitIdServicesIndexRoute: typeof AuthenticatedAccountUnitsEndCustomerUnitIdServicesIndexRoute
  AuthenticatedAccountUnitsEndCustomerUnitIdSettingsIndexRoute: typeof AuthenticatedAccountUnitsEndCustomerUnitIdSettingsIndexRoute
  AuthenticatedAccountUnitsEndCustomerUnitIdSpecificationsIndexRoute: typeof AuthenticatedAccountUnitsEndCustomerUnitIdSpecificationsIndexRoute
  AuthenticatedAccountUnitsEndCustomerUnitIdMaintenanceProtocolKeyIndexRoute: typeof AuthenticatedAccountUnitsEndCustomerUnitIdMaintenanceProtocolKeyIndexRoute
}

const AuthenticatedAccountUnitsEndCustomerUnitIdRouteRouteChildren: AuthenticatedAccountUnitsEndCustomerUnitIdRouteRouteChildren =
  {
    AuthenticatedAccountUnitsEndCustomerUnitIdIndexRoute:
      AuthenticatedAccountUnitsEndCustomerUnitIdIndexRoute,
    AuthenticatedAccountUnitsEndCustomerUnitIdCampaignsIndexRoute:
      AuthenticatedAccountUnitsEndCustomerUnitIdCampaignsIndexRoute,
    AuthenticatedAccountUnitsEndCustomerUnitIdCoverageIndexRoute:
      AuthenticatedAccountUnitsEndCustomerUnitIdCoverageIndexRoute,
    AuthenticatedAccountUnitsEndCustomerUnitIdDiagnosticsIndexRoute:
      AuthenticatedAccountUnitsEndCustomerUnitIdDiagnosticsIndexRoute,
    AuthenticatedAccountUnitsEndCustomerUnitIdMaintenanceIndexRoute:
      AuthenticatedAccountUnitsEndCustomerUnitIdMaintenanceIndexRoute,
    AuthenticatedAccountUnitsEndCustomerUnitIdPublicationsIndexRoute:
      AuthenticatedAccountUnitsEndCustomerUnitIdPublicationsIndexRoute,
    AuthenticatedAccountUnitsEndCustomerUnitIdServicesIndexRoute:
      AuthenticatedAccountUnitsEndCustomerUnitIdServicesIndexRoute,
    AuthenticatedAccountUnitsEndCustomerUnitIdSettingsIndexRoute:
      AuthenticatedAccountUnitsEndCustomerUnitIdSettingsIndexRoute,
    AuthenticatedAccountUnitsEndCustomerUnitIdSpecificationsIndexRoute:
      AuthenticatedAccountUnitsEndCustomerUnitIdSpecificationsIndexRoute,
    AuthenticatedAccountUnitsEndCustomerUnitIdMaintenanceProtocolKeyIndexRoute:
      AuthenticatedAccountUnitsEndCustomerUnitIdMaintenanceProtocolKeyIndexRoute,
  }

const AuthenticatedAccountUnitsEndCustomerUnitIdRouteRouteWithChildren =
  AuthenticatedAccountUnitsEndCustomerUnitIdRouteRoute._addFileChildren(
    AuthenticatedAccountUnitsEndCustomerUnitIdRouteRouteChildren,
  )

interface AuthenticatedAccountRouteRouteChildren {
  AuthenticatedAccountDashboardRouteRoute: typeof AuthenticatedAccountDashboardRouteRouteWithChildren
  AuthenticatedAccountFleetsFleetIdRouteRoute: typeof AuthenticatedAccountFleetsFleetIdRouteRouteWithChildren
  AuthenticatedAccountUnitsEndCustomerUnitIdRouteRoute: typeof AuthenticatedAccountUnitsEndCustomerUnitIdRouteRouteWithChildren
  AuthenticatedAccountCampaignsIndexRoute: typeof AuthenticatedAccountCampaignsIndexRoute
  AuthenticatedAccountFleetsIndexRoute: typeof AuthenticatedAccountFleetsIndexRoute
  AuthenticatedAccountMembersIndexRoute: typeof AuthenticatedAccountMembersIndexRoute
  AuthenticatedAccountUnitsIndexRoute: typeof AuthenticatedAccountUnitsIndexRoute
  AuthenticatedAccountMembersEndUserIdIndexRoute: typeof AuthenticatedAccountMembersEndUserIdIndexRoute
}

const AuthenticatedAccountRouteRouteChildren: AuthenticatedAccountRouteRouteChildren =
  {
    AuthenticatedAccountDashboardRouteRoute:
      AuthenticatedAccountDashboardRouteRouteWithChildren,
    AuthenticatedAccountFleetsFleetIdRouteRoute:
      AuthenticatedAccountFleetsFleetIdRouteRouteWithChildren,
    AuthenticatedAccountUnitsEndCustomerUnitIdRouteRoute:
      AuthenticatedAccountUnitsEndCustomerUnitIdRouteRouteWithChildren,
    AuthenticatedAccountCampaignsIndexRoute:
      AuthenticatedAccountCampaignsIndexRoute,
    AuthenticatedAccountFleetsIndexRoute: AuthenticatedAccountFleetsIndexRoute,
    AuthenticatedAccountMembersIndexRoute:
      AuthenticatedAccountMembersIndexRoute,
    AuthenticatedAccountUnitsIndexRoute: AuthenticatedAccountUnitsIndexRoute,
    AuthenticatedAccountMembersEndUserIdIndexRoute:
      AuthenticatedAccountMembersEndUserIdIndexRoute,
  }

const AuthenticatedAccountRouteRouteWithChildren =
  AuthenticatedAccountRouteRoute._addFileChildren(
    AuthenticatedAccountRouteRouteChildren,
  )

interface AuthenticatedRouteRouteChildren {
  AuthenticatedAccountRouteRoute: typeof AuthenticatedAccountRouteRouteWithChildren
  AuthenticatedSelectFleetRoute: typeof AuthenticatedSelectFleetRoute
  AuthenticatedInviteInviteIdRouteRoute: typeof AuthenticatedInviteInviteIdRouteRoute
  AuthenticatedSettingsIndexRoute: typeof AuthenticatedSettingsIndexRoute
  AuthenticatedSupportIndexRoute: typeof AuthenticatedSupportIndexRoute
  AuthenticatedWelcomeIndexRoute: typeof AuthenticatedWelcomeIndexRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedAccountRouteRoute: AuthenticatedAccountRouteRouteWithChildren,
  AuthenticatedSelectFleetRoute: AuthenticatedSelectFleetRoute,
  AuthenticatedInviteInviteIdRouteRoute: AuthenticatedInviteInviteIdRouteRoute,
  AuthenticatedSettingsIndexRoute: AuthenticatedSettingsIndexRoute,
  AuthenticatedSupportIndexRoute: AuthenticatedSupportIndexRoute,
  AuthenticatedWelcomeIndexRoute: AuthenticatedWelcomeIndexRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

interface PublicRouteRouteChildren {
  PublicFaqIndexRoute: typeof PublicFaqIndexRoute
  PublicLoginIndexRoute: typeof PublicLoginIndexRoute
}

const PublicRouteRouteChildren: PublicRouteRouteChildren = {
  PublicFaqIndexRoute: PublicFaqIndexRoute,
  PublicLoginIndexRoute: PublicLoginIndexRoute,
}

const PublicRouteRouteWithChildren = PublicRouteRoute._addFileChildren(
  PublicRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  PublicRouteRoute: PublicRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
